import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {sendEmailOTP, sendLoginOTP, verifyEmailOTP, verifyLoginOTP,verifyAdminLoginOTP} from "../../redux/reducers/authSlice";
import {snackbarContext} from '../helpers/Snakbar'
import { useNavigate } from "react-router-dom";
const TrialOtp = ({
   onContinue,
  onBack,
  login,
  otpMode
}) => {
  const setStateSnackbarContext=React.useContext(snackbarContext)
  const navigate=useNavigate()
  const [otp, setOtp] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);

  const [seconds, setSeconds] = useState(57);

  const inputRefs = useRef([]);
  const dispatch=useDispatch()
const { user } = useSelector((state) => state.auth);

  useEffect(() => {

    if (seconds <= 0) return;

    const timer = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);

  }, [seconds]);


  const handleChange = (value, index) => {

    if (!/^\d?$/.test(value)) {
      return;
    }

    const newOtp = [...otp];

    newOtp[index] = value;

    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };


  const handleKeyDown = (e, index) => {

    if (
      e.key === "Backspace" &&
      !otp[index] &&
      index > 0
    ) {
      inputRefs.current[index - 1]?.focus();
    }
  };


  // const handleVerify = () => {

  //   const value = otp.join("");

  //   if (value.length !== 6) {
  //     return;
  //   }

  //   if(login){
  //   dispatch(verifyLoginOTP({email:user,otp:value,setStateSnackbarContext,navigate}))
  //   }else{
  //    dispatch(verifyEmailOTP({email:user,otp:value,setStateSnackbarContext,navigate}))
  //   }
   
  // };

 const handleVerify = () => {

  const value = otp.join("");

  if (value.length !== 6) {
    return;
  }

  if (login) {

    // =========================================
    // ADMIN LOGIN
    // =========================================

    if (otpMode === "admin") {

      dispatch(
        verifyAdminLoginOTP({
          email: user,
          otp: value,
          setStateSnackbarContext,
          navigate
        })
      );

      return;
    }


    // =========================================
    // NORMAL LOGIN
    // =========================================

    dispatch(
      verifyLoginOTP({
        email: user,
        otp: value,
        setStateSnackbarContext,
        navigate
      })
    );

    return;
  }


  // =========================================
  // SIGNUP OTP
  // =========================================

  dispatch(
    verifyEmailOTP({
      email: user,
      otp: value,
      setStateSnackbarContext,
      navigate
    })
  );
};

  const handleResend=()=>{

    if(login){
      dispatch(sendLoginOTP({email:user,setStateSnackbarContext,onContinue,isResend:true,setSeconds,setOtp}))
    }else{
        dispatch(sendEmailOTP({email:user,setStateSnackbarContext,onContinue,
       isResend: true,
  setSeconds,
  setOtp,
    }))
    }

 
  }

  return (
    <div className="login-container">
    <div className="trial-card trial-standalone-card">

      <h2 className="trial-step-heading">
        Verify OTP
      </h2>

      <p className="trial-step-description">
        Enter the 6-digit code sent to
        <br />
        your email
      </p>


      <button
        className="trial-change-button"
        onClick={onBack}
      >
        Not you? Change email
      </button>


      <div className="trial-otp-inputs">

        {otp.map((value, index) => (

          <input
            key={index}
            ref={(element) => {
              inputRefs.current[index] = element;
            }}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={value}
            onChange={(e) =>
              handleChange(e.target.value, index)
            }
            onKeyDown={(e) =>
              handleKeyDown(e, index)
            }
            className="trial-otp-input"
          />

        ))}

      </div>


      <button
        className="trial-continue-button"
        onClick={handleVerify}
        disabled={otp.join("").length !== 6}
      >
        Verify OTP
      </button>


      <p className="trial-resend-text">
        Didn't receive the code?
      </p>

      {seconds > 0 ? (

        <span className="trial-resend-timer">
          Resend in {seconds}s
        </span>

      ) : (

        <button className="trial-resend-button" onClick={handleResend}>
          Resend OTP
        </button>

      )}

    </div>
    </div>
  );
};

export default TrialOtp;